import React from "react";
import Support from "../home/Support";
import BlogResources from "./BlogResources";
import Analytics from "./Analytics";

function Blog() {
  return (
    <div>
      <Analytics />
      <BlogResources />
      <Support />
    </div>
  );
}

export default Blog;
